import React from "react";
import styles from "./styles.css";
import HomeIcon from "./images/home-icon.svg";
import PropTypes from "prop-types";
import { appUrl } from "../../../constants/url-constants";
import SchemaBreadCrumbs from "../schema-breadcrumbs";

const BreadcrumbList = ({
    list = [],
    homeLink =  <img src={HomeIcon} />,
    onClickCallback = () => { },
    homeText = "",
    isRevamped = false,
    attachSchema = false
}) => {

    const onLinkClickHandler = (e, { item, index }) => {
        e.preventDefault();
        if (index < list.length - 1) {
            onClickCallback({ item, index });
        }
    };

    const renderList = () => (
        list.map((item, index) => (
            <span key={index}>
                {
                    item.redirectURL ?
                        <a
                            href={`${appUrl()}${item.redirectURL}`}
                            onClick={(e) => onLinkClickHandler(e, { item, index })}>
                            {item.displayText}
                        </a> : <React.Fragment>
                            {item.displayText}
                        </React.Fragment>
                }
            </span>
        ))
    );

    const getBreadcrumbList = () => {
        return [
            ...(homeText && [{displayText: homeText, redirectURL: "/"}]),
            ...list
        ];
    };

    return (
        <div  styleName={`styles.breadCrumb ${isRevamped ? "styles.revampedBreadCrumb" : ""}`}>
            <a
                href={`${appUrl()}/`}
                onClick={(e) => onLinkClickHandler(e, { item: "home", index: -1 })}>
                {
                    homeText ? homeText : homeLink
                }
            </a>
            {renderList()}
            {
                attachSchema &&
                <SchemaBreadCrumbs
                    data={getBreadcrumbList()}
                />
            }
        </div>
    );
};

BreadcrumbList.propTypes = {
    list: PropTypes.array,
    onClickCallback: PropTypes.func,
    homeLink: PropTypes.component,
    homeText: PropTypes.string,
    isRevamped: PropTypes.bool,
    attachSchema: PropTypes.bool
};

export default BreadcrumbList;
